import "./404.scss"

const NotFound = () => {
    return (
        <div className="not-found">
            <h1>404</h1>
            <h2>Page Not Found</h2>
            <p>The page you are looking for might have been removed or is temporarily unavailable.</p>
        </div>
    );
};

export default NotFound;